// © 2025 Camp Promethean, LLC. All Rights Reserved.

import {
  Calculator,
  Scale,
  TestTubes,
  Bug,
  Droplets,
  Beaker,
  Thermometer,
  Target,
  GlassWater,
  Sprout,
  NotebookPen,
  FlaskConical,
  Sun,
  ListFilter,
} from "lucide-react";

export const TOOLS = [
  {
    id: "calculator",
    name: "Shot Size Calculator",
    description: "Calculate precise shot sizes for your grow operation",
    icon: Calculator,
    path: "/arca/calculator",
    requiredTier: "free"
  },
  {
    id: "converter",
    name: "Unit Converter",
    description: "Convert between different units of measurement",
    icon: Scale,
    path: "/arca/converter",
    requiredTier: "free"
  },
  {
    id: "chemical",
    name: "Chemical Calculator",
    description: "Calculate chemical mixtures and dilutions",
    icon: TestTubes,
    path: "/arca/chemical",
    requiredTier: "free"
  },
  {
    id: "ipm",
    name: "Beneficial Insects",
    description: "Guide to beneficial insects and IPM strategies",
    icon: Bug,
    path: "/arca/ipm",
    requiredTier: "Basic"
  },
  {
    id: "agrochemlog",
    name: "Applicator Log",
    description: "Log spray applications, manage chemistries, and track REI compliance",
    icon: Beaker,
    path: "/arca/agrochemlog",
    requiredTier: "Basic"
  },
  {
    id: "photothermal",
    name: "PTR Calculator",
    description: "Calculate optimal lighting to temperature ratios for plant growth",
    icon: Thermometer, 
    path: "/arca/photothermal",
    requiredTier: "free"
  },
  {
    id: "light-lab",
    name: "Light Lab",
    description: "PPFD, DLI, ramp planning, spectrum, and energy efficiency.",
    icon: Sun,
    path: "/arca/light-lab",
    requiredTier: "free"
  },
  {
    id: "targets",
    name: "Cultivation Targets",
    description: "Define and track environment and substrate set points",
    icon: Target,
    path: "/arca/targets",
    requiredTier: "free"
  },
  {
    id: "tanks",
    name: "Tank Management",
    description: "Stock tanks, batch mixes, and fertilizer inventory.",
    icon: GlassWater,
    path: "/arca/tanks",
    requiredTier: "Basic"
  },
  {
    id: "fertility",
    name: "Fertility Tracking",
    description: "Record fertilizer, amendment, and biostimulant applications",
    icon: Sprout,
    path: "/arca/fertility",
    requiredTier: "Basic"
  },
  {
    id: "irrigation-forecaster",
    name: "Irrigation Simulator",
    description: "Simulate and predict water usage and VWC over 24 hours",
    icon: Droplets,
    path: "/arca/irrigation-forecaster",
    requiredTier: "free"
  },
  {
    id: "ppms",
    name: "PPM Analysis",
    description: "Break down nutrient regimes based on NPK guaranteed analysis",
    icon: FlaskConical,
    path: "/arca/ppms",
    requiredTier: "free"
  },
  {
    id: "filters",
    name: "Filter Management",
    description: "Track irrigation and HVAC filter cleaning and replacement",
    icon: ListFilter,
    path: "/arca/filters",
    requiredTier: "Basic"
  }
] as const;

export const tierLevels = {
  'free': 0,
  'Basic': 1,
  'Advanced': 2,
  'Professional': 3
} as const;
